import styled from '@emotion/styled';

import { theme } from 'styles/theme/theme';
import UDLink from 'ud-ui/components/link';

/** Ссылка на создание нового игрока под кнопкой «Добавить». Сам селект — `PlayerAsyncSelect`. */

export const Link = styled(UDLink)`
  text-decoration: none;
  color: ${theme.colors.LightBlue};
`;
